import type { HYSACalculatorFormFieldsKeys, HYSACalculatorStore } from './types';

export const APY_INPUT_PATTERN = /^\d{0,2}(\.\d{0,2})?$/;

type FireHysaCalculatorInteracted = (args: {
  additional_attributes: {
    annual_percentage_yield_value_input: string;
    initial_deposit_value_input: string;
    monthly_deposit_value_input: string;
    time_period_value_input: string;
  };
}) => void;

export type HandleAnnualApyInputContext = {
  fireHysaCalculatorInteractedPageAction: FireHysaCalculatorInteracted;
  initialDeposit: string;
  monthlyDeposit: string;
  timePeriod: string;
  setField: HYSACalculatorStore['setField'];
  startTransition: (fn: () => void) => void;
};

export function handleAnnualApyInput(value: string, ctx: HandleAnnualApyInputContext): void {
  if (!APY_INPUT_PATTERN.test(value)) {
    return;
  }

  const {
    fireHysaCalculatorInteractedPageAction,
    initialDeposit,
    monthlyDeposit,
    timePeriod,
    setField,
    startTransition,
  } = ctx;

  const field: HYSACalculatorFormFieldsKeys = 'annualPercentageYield';

  startTransition(() => {
    fireHysaCalculatorInteractedPageAction({
      additional_attributes: {
        annual_percentage_yield_value_input: value,
        initial_deposit_value_input: initialDeposit,
        monthly_deposit_value_input: monthlyDeposit,
        time_period_value_input: timePeriod,
      },
    });
  });

  setField(field, value);
}
